import actions from './loading/actions';
import reducer from './loading/reducer';

export {
  actions,
  reducer,
};
